import {useMutation, useQueryClient} from "@tanstack/react-query";
import {ApiError, UsersApi} from "@devour/client";
import getConfig from "@/utils/getConfig";
import {addError} from "@/redux/meta/metaActions";
import {useDispatch, useSelector} from "react-redux";
import {IStore} from "@/redux/defaultStore";
import {USE_GET_USER_PROFILE_KEY} from "@/hooks/useGetUserProfile";

export function useUpdateLeaderboardNickname() {
    const dispatch = useDispatch();
    const fullToken = useSelector((store: IStore) => store.authStore.fullToken);
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (nickname: string): Promise<void> => {
            await new UsersApi(getConfig(fullToken)).createUsersLeaderboardNickname({
                updateNicknameBody: {nickname},
            });
            queryClient.invalidateQueries({queryKey: [USE_GET_USER_PROFILE_KEY]});
        },
        onError: async (e) => {
            /*
             * Skip the global error toast when the server returned a
             * nickname-specific FormError (Taken / NotAllowed / etc.) —
             * callers surface those inline under the input field. Without
             * this guard the user would see the inline error AND a duplicate
             * global toast at the same time.
             *
             * @devour/client errors are raw Response objects, body via
             * `.json()`. Clone first so the caller's catch can still read
             * the same body — `.json()` consumes the underlying stream.
             */
            let body: any = null;
            try {
                body = await (e as any)?.clone?.()?.json();
            } catch { /* not a Response, body consumed, or invalid JSON */ }
            if (body?.formErrors?.nickname) return;
            dispatch(await addError(e as unknown as ApiError));
        },
    });
}
